import React from 'react';
import { NavItem } from '../../../../../interfaces/nav/NavMenu';
import * as classes from './NavCard.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Link from '../../../../Common/Link/Link';
import ArrowCircle from '../../../../../assets/icons/inline/arrow-circle-black.inline.svg';
import Card from '../Card/Card';

const NavCard = ({ title, description, url, label, image, color }: NavItem) => {
  const { t } = useTranslation();
  return (
    <Link title={t(title)} path={t(url)} className={classes.wrapper}>
      <div className={classes.inner}>
        <Card>
          <div className={classes.imageWrapper} style={{ backgroundColor: color }}>
            <img src={image} alt='' />
          </div>
          <div className={classes.title}>{t(label)}</div>
          <div className={classes.description}>{description && t(description)}</div>
          <div>
            <div className={classes.button}>
              <div className={classes.text}>{t('preFooter.navButtonText')}</div> <ArrowCircle />
            </div>
          </div>
        </Card>
      </div>
    </Link>
  );
};

export default NavCard;
